import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconWifi } from '@blocks-react/components/Icons/Wifi';
import { CatIconNoWifi } from '@blocks-react/components/Icons/NoWifi';
import { useMemo } from 'react';
import cx from 'classnames';
import { VisionLinkSubscriptionProp } from '../../../types';

export const VisionLinkSubscription = ({
  subscriptionType,
  connectivityType,
  isSubscribed
}: VisionLinkSubscriptionProp) => {
  const getSubscriptionIcon = useMemo(() => {
    if (isSubscribed) {
      return <CatIconWifi slot="before" className="u-color--MediumGray mt-1" />;
    } else {
      return (
        <CatIconNoWifi slot="before" className="u-color--ExtraDarkGray mt-1" />
      );
    }
  }, [isSubscribed]);
  return (
    <div className="d-flex ms-n2 ps-2">
      {getSubscriptionIcon}
      <div className="d-flex ms-2 flex-column">
        <CatHeading variant="display-sm" className="mb-1">
          <span className={cx(!isSubscribed && 'u-color--MediumGray')}>
            {connectivityType}
          </span>
        </CatHeading>
        {isSubscribed && (
          <div className="d-flex align-items-center gap-2">
            <CatHeading variant="footnote">{subscriptionType}</CatHeading>
          </div>
        )}
      </div>
    </div>
  );
};
